const BLOG_POSTS = [
  {
    slug: 'nobody-owns-the-birthday',
    category: 'Employee milestones',
    title: 'Nobody Owns the Birthday. That\'s Why It Gets Missed.',
    excerpt:
      'When the person who posts in #general is OOO, the anniversary still happens. Missed milestones are a belonging failure, not a sheet problem.',
    author: 'Casey / TryTrivia Content',
    date: 'September 1, 2026',
    readTime: '7 min read',
    featured: true,
    image:
      'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1600',
    imageAlt: 'Colleagues collaborating around a laptop in a bright office'
  },
  {
    slug: 'stop-zoom-happy-hour-bond-in-slack-teams',
    category: 'Team culture',
    title: 'Stop Booking Another Zoom Happy Hour. Bond in Slack or Teams Instead',
    excerpt:
      'Practical Slack and Teams bonding ideas that take five minutes, skip the calendar guilt, and feel less forced.',
    author: 'Casey / TryTrivia Content',
    date: 'August 22, 2026',
    readTime: '8 min read',
    image:
      'https://images.pexels.com/photos/7709166/pexels-photo-7709166.jpeg?auto=compress&cs=tinysrgb&w=1600',
    imageAlt: 'Laptops and headsets on a table'
  }
];

export default BLOG_POSTS;
